import $ from 'jquery';
import './affix.scss';
import Sloth from '../Sloth';

@Sloth.component({
    defaultOptions:{
        top : 0,
        bottom : 0,
        fixedclass : 'fixed'
    }
})

export default class Affix {
    onInit() {
        const JQdom = $(this.dom);
        this.dom.offset = JQdom.offset();
        this.dom.width = JQdom.outerWidth();
        this.dom.height = JQdom.outerHeight();
        this.dom.offset = JQdom.offset();
        this.dom.isFix = false;
        this.dom.position = JQdom.css('position');
        this.dom.bottom = typeof this.options.bottom === 'number' ? this.options : $(this.options.bottom).outerHeight(true);
        $(window).bind('scroll', (e) => {
            const _this = e.target;
            const scrollTop = $(_this).scrollTop();
            if (scrollTop > this.dom.offset.top - this.options.top) {
                this.dom.height = JQdom.outerHeight();
                this.setFix();
                if (scrollTop + this.dom.height + this.options.top > $(document).outerHeight() - this.dom.bottom) {
                    this.setFixBottom($(document).outerHeight(), scrollTop);
                } else {
                    this.quitFixBottom();
                }
            } else {
                this.quitFix();
            }
        });
        $(window).on('resize', () => {
            this.onResize();
        });
        $(window).trigger('scroll');
    }

    setFix() {
        if (this.dom.isFix) {
            return;
        }
        const JQdom = $(this.dom);
        this.dom.isFix = true;
        this.dom.offset = JQdom.offset();
        JQdom.css({
            position : 'fixed',
            top      : `${this.options.top}px`,
            left     : this.dom.offset.left,
            width    : this.dom.width,
            height   : this.dom.height
        });
        JQdom.addClass(this.options.fixedclass);
    }
    quitFix() {
        if (!this.dom.isFix) {
            return;
        }
        const JQdom = $(this.dom);
        this.dom.isFix = false;

        JQdom.css({
            position : this.dom.position,
            top : this.dom.offset.top,
            bottom : 'auto',
            width : this.dom.width,
            height : this.dom.height
        });
        JQdom.removeClass(this.options.fixedclass);
    }
    setFixBottom(documentHeight, scrollTop) {
        $(this.dom).css({
            top : documentHeight - this.dom.height - this.dom.bottom - scrollTop
        });
    }
    quitFixBottom() {
        $(this.dom).css({
            top : `${this.options.top}px`
        });
    }
    onResize() {
        $(this.dom).css('position', 'static');

        // const width = $(this.dom).parent().width();
        // const height = $(this.dom).outerHeight();

        // this.dom.width = width;
        // this.dom.height = height;
        this.dom.isFix = false;

        $(window).trigger('scroll');
    }
}



/** WEBPACK FOOTER **
 ** ./components/Affix/affix.js
 **/